export const Units = {
  extictionRiskLevelUnits: {
    label: 'Extinction Risk Level',
    title: 'Extinction Risk Level',
    options: [
      {label: 'Extinct', value: 'Extinct'},
      {
        label: 'Extinct in the Wild',
        value: 'Extinct in the Wild'
      },
      {
        label: 'Critically Endangered',
        value: 'Critically Endangered'
      },
      {label: 'Endangered', value: 'Endangered'},
      {label: 'Vulnerable', value: 'Vulnerable'},
      {label: 'Near Threatened', value: 'Near Threatened'},
      {label: 'Least Concern', value: 'Least Concern'},
      {label: 'Data Deficient', value: 'Data Deficient'},
      {label: 'Not Evaluated', value: 'Not Evaluated'}
    ]
  },
  weightUnits: {
    label: 'Weight',
    title: 'Weight',
    options: [
      {label: 'Ton', value: 'Ton'},
      {label: 'Kilogram', value: 'Kilogram'},
      {label: 'Metric Tons', value: 'Metric Tons'},
      {label: 'Pound', value: 'Pound'}
    ]
  },
  volumeUnits: {
    label: 'Volume',
    title: 'Volume',
    options: [
      {label: 'Litre', value: 'Litre'},
      {label: 'Kilolitre', value: 'Kilolitre'},
      {label: 'Gallon', value: 'Gallon'},
      {label: 'Barrels', value: 'Barrels'}
    ]
  },
  energyPowerElectricityUnits: {
    label: 'Energy / Power / Electrcity',
    title: 'Energy / Power / Electrcity',
    options: [
      {label: 'Joules', value: 'Joules'},
      {label: 'Megajoules', value: 'Megajoules'},
      {label: 'Gigajoules', value: 'Gigajoules'},
      {label: 'Kilowatt (kW)', value: 'Kilowatt (kW)'},
      {label: 'Kilowatt-hour (kWh)', value: 'kWh'},
      {label: 'Megawatt (MW)', value: 'Megawatt (MW)'},
      {label: 'Gigawatt (GW)', value: 'Gigawatt (GW)'}
    ]
  },
  areaUnits: {
    label: 'Area',
    title: 'Area',
    options: [
      {label: 'Square Feet', value: 'Square Feet'},
      {
        label: 'Square kilometer (km2)',
        value: 'Square kilometer (km2)'
      }
    ]
  },
  megaLiterUnit: 'Megaliters',
  carbonUnit: 'tCO2eq',
  Gigajoules: 'Gigajoules',
  m_3: ' m3',
  metricTonsUnit: 'MT',
  meticTonnesOfCO2Eq: 'MTCO2e',
  percentage: '%',
  kiloLitres: 'Kl',
  currencyUnit: {
    label: 'Currency',
    title: 'Currency',
    options: [
      {value: 'INR', label: 'INR'},
      {value: 'USD', label: 'USD'}
    ]
  }
};
